import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';

const styles = ({ typography }) => ({
  subtext: {
    ...typography.p3,
    '& ol': {
      listStyle: 'decimal',
      marginLeft: 20,
      marginTop: 7,
      paddingLeft: 0,
    },
    '& p': typography.p3,
    '& p:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
    },
    '& ul': {
      marginTop: 7,
      paddingLeft: 0,
    },
    display: 'inline-block',
  },
});

const Subtext = ({ children, className, classes }) => (
  <RawHtml className={classnames(className, classes.subtext)}>{children}</RawHtml>
);

Subtext.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

Subtext.defaultProps = {
  className: 'subtext',
};

export default withStyles(styles)(Subtext);
